// extracted by mini-css-extract-plugin
export default {"float_box":"index_float_box_l-INy"};